import { render, staticRenderFns } from "./arsip.vue?vue&type=template&id=7e08725d"
import script from "./arsip.vue?vue&type=script&lang=js"
export * from "./arsip.vue?vue&type=script&lang=js"
import style0 from "./arsip.vue?vue&type=style&index=0&id=7e08725d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports